import NotFoundPage from '@brands/Dashboard/NotFoundPage/NotFoundPage';
import useWindowSize from '@brands/hooks/useWindowSize';
import { CaseType } from '@brands/services/cases/types/ICase';
import { selectAuth } from '@brands/store/selectors/auth';
import { selectIsAdminLoginNewDesign } from '@brands/store/selectors/isAdminNewDesign';
import { selectPatientForm } from '@brands/store/selectors/patientForm';
import { AuthState } from '@brands/store/slices/authSlice';
import React from 'react';
import { isMobile as mobileDetect } from 'react-device-detect';
import { useSelector } from 'react-redux';

import ImageUploadMobileAdminView from '../../../../../default/Dashboard/PatientForms/PatientForm/ImageUpload/ImageUploadMobile';
import ImageUploadSecondOpinionAdminView from '../../../../../default/Dashboard/PatientForms/PatientForm/ImageUpload/ImageUploadSecondOpinion';
import ImageUploadWebAdminView from '../../../../../default/Dashboard/PatientForms/PatientForm/ImageUpload/ImageUploadWeb';
import { useAppSelector } from '../../../../hooks/useReduxHook';
import { UserRoleName } from '../../../../services/identity/types/UserProfile';
import ImageUploadMobile from './ImageUploadMobile';
import ImageUploadSecondOpinion from './ImageUploadSecondOpinion';
import ImageUploadWeb from './ImageUploadWeb';

const ImageUploadValidation: React.FC = () => {
  const user: AuthState = useAppSelector(selectAuth);
  const screenSize = useWindowSize();
  const isMobile = screenSize.width < 768 || mobileDetect;
  const { values } = useAppSelector(selectPatientForm);
  const caseType = values.find((item) => item.form_question_id === 20)?.value.caseType as string;
  const userRole = user.userInfo?.role.name;

  const isAdminNewDesign = useSelector(selectIsAdminLoginNewDesign);
  const isSecondOpinion = caseType === CaseType.second_opinion;
  const isAuthorizedUser =
    userRole === UserRoleName.Patient ||
    userRole === UserRoleName.OrganizationAdmin ||
    userRole === UserRoleName.SuperAdmin ||
    userRole === UserRoleName.Admin ||
    userRole === UserRoleName.Collector ||
    userRole === UserRoleName.CareAdvisor;
  const isNewDesignRole =
    userRole === UserRoleName.Admin ||
    userRole === UserRoleName.SuperAdmin ||
    userRole === UserRoleName.OrganizationAdmin ||
    userRole === UserRoleName.CareAdvisor ||
    userRole === UserRoleName.Collector;
  /** These roles use the same new dentistry-one UI as Collector. */
  const useAdminBrandViews = isAdminNewDesign && !isNewDesignRole;

  const renderComponent = (): JSX.Element => {
    if (!isAuthorizedUser) {
      return <NotFoundPage />;
    }

    if (isSecondOpinion) {
      if (useAdminBrandViews) {
        return <ImageUploadSecondOpinionAdminView />;
      }
      return <ImageUploadSecondOpinion />;
    }

    return isMobile ? (
      useAdminBrandViews ? (
        <ImageUploadMobileAdminView />
      ) : (
        <ImageUploadMobile />
      )
    ) : useAdminBrandViews ? (
      <ImageUploadWebAdminView />
    ) : (
      <ImageUploadWeb />
    );
  };

  return <div>{renderComponent()}</div>;
};

export default ImageUploadValidation;
